<template>
  <base-table>
    <thead>
      <tr>
        <th>Name</th>
        <th>Amount</th>
        <th>Lender</th>
        <th>Total Cost</th>
        <th>Interest Rate</th>
        <th>LTV</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(fund, key) in funding" :key="key">
        <td>{{ fund.name }}</td>
        <td>{{ $formatting.toCurrency(fund.amount) }}</td>
        <td>{{ fund.lender }}</td>
        <td>{{ $formatting.toCurrency(fund.totalCosts) }}</td>
        <td>{{ fund.interestRate }}%</td>
        <td>{{ ltv(fund) }}%</td>
        <td class="text-right">
          <div class="btn-group">
            <base-button v-tooltip="'Edit'" icon-right="pencil-alt" small @click="edit(key)" />
            <base-button v-tooltip="'Delete'" icon-right="trash" small @click="remove(key)"/>
          </div>
        </td>
      </tr>
    </tbody>
  </base-table>
</template>

<script>
import { mapState } from 'vuex'
import { EventBus, ProjectCalculations } from '@/libs'

export default {
  created () {
    this.assign()

    EventBus.$on('reloadFundingTable', () => this.assign())
  },

  data () {
    return {
      funding: []
    }
  },

  name: 'FundingTable',

  props: {
    noDestroy: Boolean,
    value: Array
  },

  computed: {
    ...mapState({
      project: store => store.core.projects.entity
    })
  },

  methods: {
    assign () {
      this.funding = this.$_.cloneDeep(this.value)
    },

    edit (index) {
      this.$emit('edit', index)
    },

    ltv (fund) {
      return new ProjectCalculations(this.project).getFundingLtv(fund)
    },

    remove (index) {
      this.$dialog.confirm('Are you sure you want to delete this funding?', async () => {
        const fund = this.funding[index]

        if (this.noDestroy) {
          this.$emit('removing', fund)
        } else {
          await this.$store.dispatch('core/project-funding/remove', fund._id)
        }

        this.funding.splice(index, 1)

        this.$emit('remove', fund)
      })
    }
  },

  watch: {
    funding: {
      deep: true,
      handler () {
        this.$emit('input', this.funding)
      }
    }
  }
}
</script>
